var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popconfirm',{staticStyle:{"color":"#f5222d"},attrs:{"ok-type":"danger","title":"是否确定删除？"},on:{"confirm":_vm.confirm}},[_c('a-icon',{attrs:{"slot":"icon","type":"question-circle-o"},slot:"icon"}),_c('a-button',{attrs:{"icon":"delete","size":"small","type":"link"}},[_vm._v("删除")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }